function isTamaguiComponent(comp, name) {
  const config = comp == null ? void 0 : comp["staticConfig"];
  return Boolean(config && (name ? name === config.componentName : true));
}
export {
  isTamaguiComponent
};
//# sourceMappingURL=isTamaguiComponent.js.map
